import { render } from "./Invoice.vue?vue&type=template&id=0980219d&scoped=true"
import script from "./Invoice.vue?vue&type=script&lang=js"
export * from "./Invoice.vue?vue&type=script&lang=js"

import "./Invoice.vue?vue&type=style&index=0&id=0980219d&scoped=true&lang=css"

import exportComponent from "/Users/shan/www/xnz_merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0980219d"]])

export default __exports__